<button
  avButton
  size="xs"
  (click)="change(pageIndex() - 1)"
  [disabled]="pageIndex() === 0"
>
  &larr;
</button>
<div class="pages">
  @for (page of pages; track page) {
  <button
    avButton
    size="xs"
    [color]="pageIndex() === page ? 'accent' : 'basic'"
    (click)="change(page)"
  >
    {{ page + 1 }}
  </button>
  }
</div>
<button
  avButton
  size="xs"
  (click)="change(pageIndex() + 1)"
  [disabled]="totalPages === pageIndex() + 1"
>
  &rarr;
</button>
